import _BaseAPIService from "../../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const DestinationWidgetService = {
  getList: async () => {
    try {
      const response = await apiService.get("/destinationcountrywidgets");
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
  update: async (id, updatedData) => {
    try {
      const response = await apiService.put(
        `/destinationcountrywidgets/${id}`,
        updatedData,
      );
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
  create: async (data) => {
    const response = await apiService.post("/destinationcountrywidgets", data);
    return response.data;
  },

  getdetail: async (id) => {
    const response = await apiService.get(
      `/destinationcountrywidgets/bydestinationcountry/${id}`,
    );
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(
      `/destinationcountrywidgets/harddelete/${id}`,
    );
    return response.data;
  },
  deleteMain: async (id) => {
    const response = await apiService.delete(
      `/destinationcountrywidgets/delete-main/${id}`,
    );
    return response.data;
  },
};

export default DestinationWidgetService;
